module.exports = __webpack_public_path__ + "img/echart_bj.721f29c0.png";